import * as couponCommentTypes from "../types/couponCommentTypes";
import * as couponCommentServices from "../../services/couponCommentServices";
import { mergeCoupon } from "./couponActions";

export const fetchCouponComments =
  (couponPublicId, params = {}) =>
  async (dispatch) => {
    dispatch({
      type: couponCommentTypes.COUPON_COMMENTS_FETCH_REQUEST,
      payload: { couponPublicId },
    });
    try {
      const comments = await couponCommentServices.listCouponComments(
        couponPublicId,
        params
      );
      dispatch({
        type: couponCommentTypes.COUPON_COMMENTS_FETCH_SUCCESS,
        payload: { couponPublicId, comments },
      });
    } catch (e) {
      dispatch({
        type: couponCommentTypes.COUPON_COMMENTS_FETCH_FAILURE,
        payload:
          e?.response?.data?.message ||
          e?.message ||
          "Could not load comments",
      });
    }
  };

export const createCouponComment =
  (couponPublicId, body) => async (dispatch) => {
    dispatch({
      type: couponCommentTypes.COUPON_COMMENT_CREATE_REQUEST,
      payload: { couponPublicId },
    });
    try {
      const data = await couponCommentServices.createCouponComment(
        couponPublicId,
        body
      );
      dispatch({
        type: couponCommentTypes.COUPON_COMMENT_CREATE_SUCCESS,
        payload: {
          couponPublicId,
          comment: data.comment,
        },
      });
      if (data.coupon) dispatch(mergeCoupon(data.coupon));
      return true;
    } catch (e) {
      dispatch({
        type: couponCommentTypes.COUPON_COMMENT_CREATE_FAILURE,
        payload:
          e?.response?.data?.message ||
          e?.message ||
          "Could not post comment",
      });
      return false;
    }
  };

export const updateCouponComment =
  (couponPublicId, commentId, body) => async (dispatch) => {
    dispatch({
      type: couponCommentTypes.COUPON_COMMENT_UPDATE_REQUEST,
      payload: { couponPublicId, commentId },
    });
    try {
      const comment = await couponCommentServices.updateCouponComment(
        couponPublicId,
        commentId,
        body
      );
      dispatch({
        type: couponCommentTypes.COUPON_COMMENT_UPDATE_SUCCESS,
        payload: { couponPublicId, comment },
      });
    } catch (e) {
      dispatch({
        type: couponCommentTypes.COUPON_COMMENT_UPDATE_FAILURE,
        payload:
          e?.response?.data?.message ||
          e?.message ||
          "Could not update comment",
      });
    }
  };

export const deleteCouponComment =
  (couponPublicId, commentId) => async (dispatch) => {
    dispatch({
      type: couponCommentTypes.COUPON_COMMENT_DELETE_REQUEST,
      payload: { couponPublicId, commentId },
    });
    try {
      const data = await couponCommentServices.deleteCouponComment(
        couponPublicId,
        commentId
      );
      dispatch({
        type: couponCommentTypes.COUPON_COMMENT_DELETE_SUCCESS,
        payload: { couponPublicId, commentId },
      });
      if (data?.coupon) dispatch(mergeCoupon(data.coupon));
    } catch (e) {
      dispatch({
        type: couponCommentTypes.COUPON_COMMENT_DELETE_FAILURE,
        payload:
          e?.response?.data?.message ||
          e?.message ||
          "Could not delete comment",
      });
    }
  };
